const base64Table = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "+",
  "/",
];

class BinaryArrayWriter {
  constructor() {
    this.array = [[]];
    this.arrayIndex = 0;
  }

  write(width, value) {
    for (var i = 0; i < width; i++) {
      this.array[this.arrayIndex].unshift((value >> i) & 1);
      if (this.array[this.arrayIndex].length == 6) {
        this.arrayIndex += 1;
        this.array[this.arrayIndex] = [];
      }
    }
  }

  toExportString() {
    let string = "";

    // 0-padding the last value.
    while (this.array[this.arrayIndex].length != 6) {
      this.array[this.arrayIndex].unshift(0);
    }

    for (var i = 0; i < this.array.length; i++) {
      // Computing the value represented by the array of bits
      let value =
        this.array[i][5] * 1 +
        this.array[i][4] * 2 +
        this.array[i][3] * 4 +
        this.array[i][2] * 8 +
        this.array[i][1] * 16 +
        this.array[i][0] * 32;
      string += base64Table[value];
    }

    return string;
  }
}

const getTalentExportString = (specID, nodeConfig) => {
  const binaryArray = new BinaryArrayWriter();
  // Serialization Version = 1 on 8 bits
  binaryArray.write(8, 1);
  binaryArray.write(16, specID);
  // tree hash, 16 8-bits words that are all 0
  for (var i = 0; i < 16; i++) {
    binaryArray.write(8, 0);
  }
  for (var i = 0; i < Object.values(nodeConfig).length; i++) {
    const node = Object.values(nodeConfig)[i];
    if (node.isSelected) {
      binaryArray.write(1, 1);
      if (node.isPartiallyFilled) {
        binaryArray.write(1, 1);
        binaryArray.write(6, node.pointsInvested);
      } else {
        binaryArray.write(1, 0);
      }
      if (node.isChoiceNode) {
        binaryArray.write(1, 1);
        binaryArray.write(2, node.choiceEntrySelected);
      } else {
        binaryArray.write(1, 0);
      }
    } else {
      binaryArray.write(1, 0);
    }
  }

  return binaryArray.toExportString();
};

export default getTalentExportString;
